/* SKN&B gift guard — auto-adds/removes the free Gua Sha (GWP).
 *
 * The admin automatic "Buy X Get Y" discount (min spend -> gift 100% off) never
 * adds the gift to the cart by itself (Shopify: the get-item "is never
 * automatically added to the cart"). This script owns that lifecycle:
 *   - eligible subtotal (cart minus gift lines) >= threshold  -> add the gift
 *   - our gift line exists but is NOT free (dropped below threshold, or a
 *     currency-rate mismatch made the add premature) -> remove it, so the
 *     customer is never silently charged for a "free" gift
 *   - after adding, re-read the cart and verify the discount actually zeroed
 *     the line; roll back immediately if it didn't (self-correcting in EUR,
 *     where the threshold is a rate conversion)
 *   - if the customer manually deletes the gift, respect it for the session
 * Config comes from [data-sknb-gift] attributes rendered by the reward bar /
 * routine section. Thresholds are in cents; non-SEK uses Shopify.currency.rate
 * with the Liquid-derived presentment threshold as fallback.
 */
(function () {
  var OPTOUT_KEY = 'sknb_gift_optout_v1';
  var SEEN_KEY = 'sknb_gift_seen_v1';
  var SOURCE = 'sknb-gift';
  var busy = false;
  var timer = null;

  function ss(action, key, value) {
    try {
      if (action === 'get') return sessionStorage.getItem(key);
      if (action === 'set') sessionStorage.setItem(key, value);
      if (action === 'del') sessionStorage.removeItem(key);
    } catch (e) {}
    return null;
  }

  function config() {
    return document.querySelector('[data-sknb-gift]');
  }

  function threshold(cfg, currency) {
    var sek = parseInt(cfg.getAttribute('data-gift-threshold-sek'), 10) || 0;
    if (!sek) return 0;
    if (currency === 'SEK') return sek;
    var rate = window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate);
    if (rate && rate > 0) return Math.round(sek * rate);
    return parseInt(cfg.getAttribute('data-gift-threshold-presentment'), 10) || 0;
  }

  function notify(cart) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, sourceId: SOURCE, data: { source: SOURCE, itemCount: cart.item_count } },
      })
    );
  }

  function getCart() {
    return fetch('/cart.js').then(function (r) { return r.ok ? r.json() : null; });
  }

  function removeLine(line) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: line.key, quantity: 0 }),
    });
  }

  async function sync() {
    var cfg = config();
    if (!cfg || busy) return;
    busy = true;
    try {
      var handle = cfg.getAttribute('data-gift-handle');
      var variantId = parseInt(cfg.getAttribute('data-gift-variant'), 10);
      if (!handle || !variantId) return;

      var cart = await getCart();
      if (!cart) return;

      var thr = threshold(cfg, cart.currency);
      if (!thr) return;

      var giftLines = cart.items.filter(function (i) { return i.handle === handle; });
      var eligible = cart.items.reduce(function (sum, i) {
        return i.handle === handle ? sum : sum + i.final_line_price;
      }, 0);
      var ourPaidGift = giftLines.filter(function (i) {
        return i.final_line_price > 0 && i.properties && i.properties._sknb_gift;
      })[0];
      // Track ANY gift-product line (ours or e.g. the routine builder's): if the
      // customer had one and deleted it themselves, respect that for the session
      // instead of bouncing it back in.
      var giftPresent = giftLines.length > 0;
      if (!giftPresent && ss('get', SEEN_KEY) === '1') {
        ss('del', SEEN_KEY);
        ss('set', OPTOUT_KEY, '1');
      }
      if (giftPresent) ss('set', SEEN_KEY, '1');

      if (ourPaidGift) {
        // Below threshold (or premature add): never charge for the "gift".
        ss('del', SEEN_KEY);
        await removeLine(ourPaidGift);
        var afterRemove = await getCart();
        if (afterRemove) notify(afterRemove);
        return;
      }

      if (ss('get', OPTOUT_KEY) === '1') return;

      if (eligible >= thr && giftLines.length === 0) {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { _sknb_gift: '1' } }] }),
        });
        if (!res.ok) return; // e.g. sold out — fail quietly, bar copy stays honest
        var cart2 = await getCart();
        if (!cart2) return;
        var added = cart2.items.filter(function (i) {
          return i.handle === handle && i.properties && i.properties._sknb_gift;
        })[0];
        if (added && added.final_line_price > 0) {
          // Discount did not apply (rate drift) — roll back before anyone pays.
          await removeLine(added);
          return;
        }
        ss('set', SEEN_KEY, '1');
        notify(cart2);
      }
    } catch (e) {
    } finally {
      busy = false;
    }
  }

  function schedule() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () { timer = null; sync(); }, 250);
  }

  document.addEventListener('cart:update', function (e) {
    var src = e && e.detail && e.detail.data && e.detail.data.source;
    if (src === SOURCE) return;
    schedule();
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  window.addEventListener('pageshow', schedule);
})();
